import { GET, POST } from "./_config";

//user
export const addContactUsData = async (body) => await POST("/contactUs", body);

//admin
export const getContactUsList = async (query) =>
  await GET(`/contactUs/get-contactUs-list?${query || ""}`, true);
